import React, {useEffect, useState} from "react";
import {styled} from '@mui/material/styles';
import {Grid, Button, ListItem, ListItemText, IconButton, CssBaseline, Toolbar, Avatar, Box, ListItemAvatar, Typography, Menu, Divider, List} from "@mui/material";
import MuiAppBar from '@mui/material/AppBar';
import MenuIcon from '@mui/icons-material/Menu';
import AppLogo from "../assets/images/oviguard-logo.png";
import DrawerHeader from "./drawer-header";
import useWidth from "../hooks/useWidth";
import Sidebar from "./sidebar";
import {stringAvatar} from "../utils/stringAvatarUtil";
import NotificationsIcon from "@mui/icons-material/Notifications";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import {useMsal} from "@azure/msal-react";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccountPopperComponent from "./account-popper.component";
import useNotification from "../hooks/useNotification";
import moment from "moment";
import CloseIcon from "@mui/icons-material/Close";
import {useNavigate} from "react-router-dom";

const drawerWidth = 250;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
  })(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
}));

const MainLayout = ({children}) => {
  const {accounts} = useMsal();
  const userDetails = accounts[0]?.idTokenClaims?.emails[0];

  const {isFetchingNotifications, notificationList, getNotificationList} = useNotification();
  
  const [anchorEl, setAnchorEl] = useState(null);
  const openAccountPopper = Boolean(anchorEl);
  const [notificationData, setNotificationData] = useState([]);
  const [notificationAnchorEl, setNotificationAnchorEl] = useState(null);
  const openNotification = Boolean(notificationAnchorEl);

  const breakpoints = useWidth();
  const navigate = useNavigate();

  const [open, setOpen] = useState(true);

  useEffect(() => {
    let parameters = {
      page: 1,
      limit: 10
    }

    getNotificationList(parameters);
  }, [])

  useEffect(() => {
    if (notificationList && notificationList?.length > 0) {
      setNotificationData(notificationList);
    }
  }, [notificationList])


  const handleDrawerOpen = () => {
    setOpen(true); 
  }

  const handleDrawerClose = () => {
    setOpen(false);
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  }

  const handleCloseMenu = () => {
    setAnchorEl(null);
  }

  const handleOpenNotification = (event) => {
    setNotificationAnchorEl(event.currentTarget);
  }

  const handleCloseNotification = () => {
    setNotificationAnchorEl(null);
  }

  
  return (
    <Box sx={{display: "flex"}}>
      <CssBaseline />

      <AppBar position="fixed" open={open} sx={{width: (breakpoints == 'xs' || breakpoints == 'sm') ? "100%" : {}, backgroundColor: "#fff", height: 64, boxShadow: '0px 2px 4px -1px rgb(0 0 0 / 11%), 0px 4px 5px 0px rgb(0 0 0 / 3%), 0px 1px 10px 0px rgb(0 0 0 / 3%)'}}>
        <Toolbar sx={{paddingLeft: (breakpoints == 'xs' || breakpoints == 'sm') ? "0px !important" : {}, paddingRight: (breakpoints == 'xs' || breakpoints == 'sm') ? "0px !important" : {}}}>
          
          {(breakpoints == 'md' || breakpoints == 'lg' || breakpoints == 'xl') && 
            <IconButton edge="start" color="inherit" aria-label="open drawer"
              onClick={handleDrawerOpen}
              sx={{mr: 5, ...(open && {display: 'none'})}}
            >
              <MenuIcon sx={{color: "black"}} />
            </IconButton>
          }

          <Button type="button" sx={{cursor: "default", ...(open && {display: 'none'}), ...((breakpoints == 'xs' || breakpoints == 'sm') && {display: "visible"})}}
          onClick={(e) => navigate('/dashboard')}>
            <img alt="ovcode-admin-logo" src={AppLogo} style=
              {{
                cursor: "pointer", height: (breakpoints == 'xs' || breakpoints == 'sm') ? 70 : 50, 
                padding: (breakpoints == "xs" || breakpoints == "sm") ? {} : "4px"
              }}               
            />
          </Button>

          <Grid sx={{ml: "auto"}}>
            <>
              <IconButton 
                aria-label="notification" 
                sx={{padding: "5px"}} 
                aria-controls={openNotification ? "account-menu" : undefined}
                aria-expanded={openNotification ? "true" : undefined}
                aria-haspopup="true"
                onClick={handleOpenNotification}
              >
                <NotificationsIcon sx={{color: "#3333cf"}} />
              </IconButton>

              <Menu
                anchorEl={notificationAnchorEl}
                open={openNotification}
                onClose={handleCloseNotification}
                slotProps={{
                  paper: {style: {width: "330px", maxHeight: "auto", overflowY: "auto", borderRadius: "8px"}}
                }}
              >
                <Grid container sx={{borderBottom: "1px solid #f1eaea", padding: "8px 18px"}}>
                  <Grid item xs={6}>
                    <Typography variant="h6" sx={{fontWeight: "bold", color: "#58565f", fontSize: 20}}>
                      Notifications
                    </Typography>
                  </Grid>

                  <Grid item xs={6} sx={{textAlign: "right"}}>
                    <CloseIcon sx={{fontSize: "18px", color: "#A4A4A4", cursor: "pointer", mt: "0px"}} onClick={handleCloseNotification} />
                  </Grid>
                </Grid>

                {notificationData?.length > 0 ? (
                  <List className="notifications-scrollbar">
                    {notificationData?.map((notification) => (
                      <>
                        <React.Fragment key={notification.notification_id}>
                          <ListItem alignItems="flex-start" sx={{}}>
                            <ListItemAvatar>
                              <Avatar sx={{bgcolor: "#5959D8"}}>
                                {notification.module.charAt(0)}
                              </Avatar>
                            </ListItemAvatar>

                            <ListItemText 
                              primary={
                                <Typography sx={{fontWeight: "bold", color: "#58565f", fontSize: 16}}>
                                  {notification.title}
                                </Typography>
                              }
                              secondary={
                                <>
                                  <Typography component="span" variant="body2" color="#58565f">
                                    {notification.message}
                                  </Typography>

                                  <br />

                                  <Grid sx={{display: "flex", justifyContent: "end"}}>
                                    <Typography variant="caption" component="span" sx={{color: "rgb(0 0 0 / 42%)"}}>
                                      {moment(notification.created_time).fromNow()}
                                    </Typography>
                                  </Grid>
                                </>
                              }
                            />
                          </ListItem>
                        </React.Fragment> 

                        <Divider variant="inset" sx={{ml: "16px", mr: "16px", border: "1px solid #d8d8d8"}} />
                      </>
                    ))}
                  </List>

                ) : (

                  <Typography sx={{color: "#58565f", fontSize: 16, textAlign: "center", padding: "45px 20px"}}>
                    No notifications available
                  </Typography>
                )}
              </Menu>
            </>

            <IconButton aria-label="toggle-darkmode" sx={{padding: "5px"}}>
              <DarkModeIcon sx={{color: "#3333cf"}} />
            </IconButton>
          </Grid>
        

          <ListItem sx={{width: "auto"}}>
            <IconButton
              size="small"
              sx={{ ml: 0.1 }}
            >
              <ListItemAvatar sx={{minWidth: 0}}>
                <Avatar 
                {...stringAvatar(userDetails)} 
                style=
                  {{cursor: "default", width: 40, height: 40, backgroundColor: "#7a78f7", 
                    fontSize: 14, alignItems: "center", border: "5px solid #3f6cf2"
                  }} 
                />
              </ListItemAvatar>
            </IconButton>

            {(breakpoints == "md" || breakpoints == "lg" || breakpoints == "xl") && 
              <ListItemText sx={{display: "inline-grid"}}
                primary={
                  <Typography sx={{fontWeight: "bold", color: "#58565f", margin: "3px 0px 0px 3px", textAlign: "justify", fontSize: 13}}>
                    {userDetails}
                  </Typography>
                }
                secondary={
                  <Typography sx={{color: "#58565F87", margin: "-4px 0px 0px 3px", textAlign: "justify", fontSize: 10}}>
                    Enterprise
                  </Typography>
                }
              />
            }

            <>
              <IconButton
                size="small"
                sx={{ml: 0.1}}
                aria-label="dropdown-menu"
                aria-controls={openAccountPopper ? "notification" : undefined}
                aria-expanded={openAccountPopper ? "true" : undefined}
                aria-haspopup="true"
                onClick={handleClick}
              >
                <ExpandMoreIcon fontSize="medium" sx={{color: "#5959D8"}} />
              </IconButton> 

                <AccountPopperComponent 
                  anchorEl={anchorEl} 
                  openAccountPopper={openAccountPopper}
                  handleCloseMenu={handleCloseMenu} 
                  setAnchorEl={setAnchorEl}
                /> 
            </> 
          </ListItem>  
        </Toolbar>
      </AppBar>

      {/* left sidebar  */}
      {(breakpoints == "md" || breakpoints == "lg" || breakpoints == "xl") && 
        <Sidebar open={open} handleDrawerClose={handleDrawerClose} />
      }

      <Box component="main" sx={{flexGrow: 1, p: (breakpoints == "xs") ? 1 : 3 , pt: 3, width: "100%", overflowX: "hidden"}}>
        <DrawerHeader /> 

        {(breakpoints == "xs" || breakpoints == "sm") &&  <DrawerHeader />}  

        {children}   
      </Box>
    </Box>
  )

}

export default MainLayout

